export const MELISSA_PHOTO = "https://static.prod-images.emergentagent.com/jobs/37ee5b2a-63c4-4546-b403-bdf2c5119992/images/bfa88cc6661f7cbb574824250d4bed9dc38110462ca084fc00ac40aea9066fb0.png";

export const HERO_IMAGE = "https://images.unsplash.com/photo-1762811054950-b74e0a055c80?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

export const HERO_PERSON = "/melissa-fullbody.png";

export const AREAS = [
  {
    name: "Redlands",
    slug: "redlands",
    state: "CA",
    price: "$875,000",
    beds: 4,
    baths: 3,
    sqft: "2,840",
    image: "https://images.unsplash.com/photo-1577618163295-29d57a40e2b2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    blurb: "Historic charm meets modern living in this sought-after foothill community.",
    tagline: "Historic charm, foothill living",
    intro: "Tree-lined streets, restored Victorians, and a vibrant downtown make Redlands one of the Inland Empire's most beloved communities. With top schools, the University of Redlands, and easy freeway access, it's a favorite for families and investors alike.",
    highlights: ["Top-rated schools & university town", "Walkable historic downtown", "Strong, steady appreciation", "Quick access to the 10 & 210 freeways"],
    nearby: ["Loma Linda", "Yucaipa", "Mentone", "Highland", "Grand Terrace", "Beaumont"]
  },
  {
    name: "Palm Springs",
    slug: "palm-springs",
    state: "CA",
    price: "$1,425,000",
    beds: 3,
    baths: 3,
    sqft: "2,310",
    image: "https://images.unsplash.com/photo-1709418354364-8f3e9ad5c32c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    blurb: "Iconic desert-modern architecture with mountain views and resort living.",
    tagline: "Desert-modern resort living",
    intro: "World-famous for mid-century modern architecture, mountain views, and a year-round resort lifestyle, Palm Springs is both a dream home destination and a powerhouse for short-term rental investment.",
    highlights: ["Iconic mid-century architecture", "Strong vacation-rental income potential", "Year-round sunshine & tourism", "Pools, golf, and mountain views"],
    nearby: ["Cathedral City", "Rancho Mirage", "Palm Desert", "Desert Hot Springs", "La Quinta", "Indian Wells"]
  },
  {
    name: "Temecula",
    slug: "temecula",
    state: "CA",
    price: "$960,000",
    beds: 5,
    baths: 4,
    sqft: "3,180",
    image: "https://images.unsplash.com/photo-1510627489930-0c1b0bfb6785?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    blurb: "Wine-country living with spacious estates and award-winning schools.",
    tagline: "Wine country, room to grow",
    intro: "Rolling vineyards, spacious newer estates, and award-winning schools make Temecula a magnet for growing families. Wine country charm with strong value-per-square-foot keeps demand high.",
    highlights: ["Award-winning wine country", "Larger lots & newer construction", "Excellent schools", "Family-friendly master-planned communities"],
    nearby: ["Murrieta", "Menifee", "Wildomar", "Lake Elsinore", "Fallbrook", "Winchester"]
  }
];

// Each region grouped with its surrounding cities, for dropdowns / quiz selects.
export const AREA_GROUPS = AREAS.map((a) => ({
  label: `${a.name} & surrounding`,
  options: [`${a.name}, ${a.state}`, ...a.nearby]
}));

export const SERVICES = [
  {
    title: "AI-Driven Pricing",
    desc: "Predictive market analytics price your home to sell faster and for more — not guesswork, data."
  },
  {
    title: "3D Tours & Drone Media",
    desc: "Cinematic listings with immersive virtual walkthroughs that reach buyers anywhere, anytime."
  },
  {
    title: "Targeted Digital Marketing",
    desc: "Your property in front of the right buyers across social, search, and the Zillow network."
  },
  {
    title: "Real-Time Deal Tracking",
    desc: "A transparent client dashboard keeps you informed at every milestone of your transaction."
  }
];

export const REVIEWS = [
  {
    name: "Grateful Homebuyer",
    location: "First-Time Buyer",
    text: "She was God sent to me. I needed to buy a home right away. She went above and beyond, holding my hand all the way. I love you and miss you Melissa. Thank you for being with me every step of the way. I recommend you to everyone. God bless you and thank you so much for helping me find my new and perfect home!"
  },
  {
    name: "Relisted Seller",
    location: "Seller",
    text: "My property had been on the market with a different Realtor for 6 months with little action. We took it off and within a week Melissa had found us a buyer, so we relisted with her. It was a difficult process that Melissa handled with professional expertise — coordinating two escrow companies and two other Realtors to ensure the purchases went through. I don't envy her job, but she handled it speedily and with professionalism."
  },
  {
    name: "Investment Property Client",
    location: "Investor",
    text: "Melissa helped us with the purchase of an investment property. She was incredibly patient as we viewed multiple homes — thorough, organized, and attentive to our every detail. She was a pleasure to work with as we went through the paperwork for our property. She truly is an all-star!"
  },
  {
    name: "First-Home Buyers",
    location: "First-Time Buyers",
    text: "Melissa was a tremendous partner on the way to our first home purchase. She was kind and always open for communication. Melissa is an all-around professional who will advocate for her client with a certain tenacity but also with tact. We couldn't be more pleased with our experience, and that is due, extensively, to Melissa's skills as a real estate professional."
  }
];

export const BUYER_QUESTIONS = [
  {
    id: "timeline",
    q: "When are you hoping to buy?",
    options: ["Within 30 days", "1–3 months", "3–6 months", "Just exploring"]
  },
  {
    id: "priority",
    q: "What matters most in a realtor for you?",
    options: ["Deep local market knowledge", "Aggressive negotiation", "Patient guidance & education", "Fast, tech-driven communication"]
  },
  {
    id: "property",
    q: "What type of property are you after?",
    options: ["Primary residence", "Investment property", "Foreclosure / fixer", "Vacation home"]
  },
  {
    id: "area",
    q: "Which area interests you most?",
    options: ["Redlands", "Palm Springs", "Temecula", "Not sure yet"]
  },
  {
    id: "financing",
    q: "Where are you with financing?",
    options: ["Pre-approved", "Cash buyer", "Need a lender referral", "Still figuring it out"]
  }
];

export const SELLER_QUESTIONS = [
  {
    id: "timeline",
    q: "When are you looking to sell?",
    options: ["ASAP", "1–3 months", "3–6 months", "Curious about my value"]
  },
  {
    id: "priority",
    q: "What do you value most in a listing agent?",
    options: ["Top dollar pricing strategy", "Cutting-edge marketing", "Smooth, stress-free process", "Honest communication"]
  },
  {
    id: "property",
    q: "What are you selling?",
    options: ["Single-family home", "Condo / townhome", "Investment property", "Multiple properties"]
  },
  {
    id: "area",
    q: "Where is your property located?",
    options: ["Redlands", "Palm Springs", "Temecula", "Other SoCal area"]
  },
  {
    id: "condition",
    q: "How would you describe its condition?",
    options: ["Move-in ready", "Needs minor updates", "Needs major work", "Not sure"]
  }
];

export const SELLER_GUIDE_IMAGE = "https://customer-assets.emergentagent.com/job_nextgen-homes-ca/artifacts/fg1n82l9_ChatGPT%20Image%20Jul%204%2C%202026%2C%2011_53_02%20AM.png";

// Lead-magnet: free, email-gated relocation guide (PDF lives in /public)
export const RELOCATION_GUIDE_PDF = "/moving-to-inland-empire-guide.pdf";

// Relocation-focused city landing pages (separate from the "sold home" AREAS above)
export const CITY_GUIDES = [
  {
    slug: "yucaipa",
    name: "Yucaipa",
    state: "CA",
    tagline: "Space, value & a laid-back foothill lifestyle",
    image: "https://images.unsplash.com/photo-1673286121437-ee387585d986?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    blurb: "Newer homes, bigger lots, and a relaxed semi-rural feel just up the hill from Redlands — one of the Inland Empire's most-searched relocation cities.",
    intro: "Yucaipa gets searched constantly by families moving out of Los Angeles and Orange County — often people who'd never heard of it until a home search pointed them there. The appeal is simple: newer homes, bigger lots, mountain views, and a genuinely relaxed lifestyle, all at prices well below the coast. It's a place where kids can have a real backyard and families can slow down without giving up freeway access.",
    stats: [
      { label: "Vibe", value: "Semi-rural & relaxed" },
      { label: "Best for", value: "Space & value seekers" },
      { label: "Nearby", value: "Oak Glen · Big Bear" },
      { label: "Commute", value: "I-10 corridor access" }
    ],
    whyMove: [
      "Newer construction and larger lots for the money",
      "Oak Glen apple orchards & local wineries minutes away",
      "Yucaipa Regional Park — lakes, trails & camping",
      "Quick drives to Big Bear and the mountains",
      "Family-friendly, community-minded atmosphere",
      "Lower price-per-square-foot than neighboring Redlands"
    ],
    lifestyle: "Life in Yucaipa is unhurried. Weekends might mean cider and apple picking up in Oak Glen, a hike or a day at Yucaipa Regional Park, or a quick run up to Big Bear. The trade-off for all that space is a more car-oriented, spread-out town — but for most relocating buyers, that's exactly the point.",
    consider: "Yucaipa is less walkable than a downtown-centric town, so you'll drive more for errands and dining. Map your commute honestly before you buy — but expect far more house and land than comparable coastal budgets allow.",
    nearby: ["Calimesa", "Redlands", "Mentone", "Beaumont", "Oak Glen"],
    relatedPosts: [
      { slug: "is-yucaipa-ca-a-good-place-to-live", title: "Is Yucaipa, CA a Good Place to Live?" },
      { slug: "redlands-vs-yucaipa-which-city-is-right-for-you", title: "Redlands vs Yucaipa — Which City is Right for You?" },
      { slug: "living-in-redlands-ca-what-buyers-need-to-know", title: "Living in Redlands, CA — What Buyers Need to Know" }
    ]
  },
  {
    slug: "highland",
    name: "Highland",
    state: "CA",
    tagline: "Foothill value with room to grow",
    image: "https://images.unsplash.com/photo-1720660395500-47ee4a3dbcf8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    blurb: "A mix of established and newer neighborhoods climbing toward the San Bernardino foothills, with attractive pricing and mountain views — an under-the-radar IE value play.",
    intro: "Just north of Redlands and San Bernardino, Highland is one of those Inland Empire cities that flies under the radar for out-of-area buyers — until they see how much home they can get for their money. If you're relocating from LA or Orange County and want space, foothill views, and value, Highland deserves a serious look.",
    stats: [
      { label: "Vibe", value: "Foothill suburban" },
      { label: "Best for", value: "More space for less" },
      { label: "Nearby", value: "San Bernardino Forest" },
      { label: "Commute", value: "210 freeway access" }
    ],
    whyMove: [
      "Lower price-per-square-foot than Redlands",
      "Established and newer neighborhoods with mountain backdrops",
      "Close to the San Bernardino National Forest & hiking trails",
      "Quick 210 freeway access and nearby Redlands amenities",
      "A short drive to Big Bear and mountain recreation",
      "Generous lots and room for growing families"
    ],
    lifestyle: "Highland pairs a convenient location with attractive pricing. You'll find neighborhoods climbing toward the foothills, many with generous lots and mountain views, plus easy access to shopping, dining, and the outdoors. It's an easy way to get more square footage without straying far from the freeway.",
    consider: "Like much of the IE, Highland is more car-oriented than a walkable coastal town. Map your commute and daily errands — for most relocating families, the extra space and lower prices are well worth it.",
    nearby: ["Redlands", "San Bernardino", "Loma Linda", "Mentone", "Yucaipa"],
    relatedPosts: [
      { slug: "is-highland-ca-a-good-place-to-live", title: "Is Highland, CA a Good Place to Live?" },
      { slug: "moving-to-inland-empire-from-la-orange-county", title: "Moving to the IE from LA or OC: Loma Linda, Highland & Calimesa" },
      { slug: "living-in-redlands-ca-what-buyers-need-to-know", title: "Living in Redlands, CA — What Buyers Need to Know" }
    ]
  },
  {
    slug: "loma-linda",
    name: "Loma Linda",
    state: "CA",
    tagline: "Health, community & central convenience",
    image: "https://images.unsplash.com/photo-1758544919202-968bb1a826b0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    blurb: "One of America's healthiest communities, anchored by a world-renowned medical university — a favorite for medical professionals and families who value convenience and walkability.",
    intro: "Loma Linda is unlike anywhere else in the Inland Empire. Anchored by a world-renowned medical university and hospital, it's one of the few 'Blue Zones' in America — a community known for healthy living and longevity. For medical professionals and families who value convenience, walkability, and a tight-knit community, it's a compelling place to call home.",
    stats: [
      { label: "Vibe", value: "Health-focused & walkable" },
      { label: "Best for", value: "Medical professionals" },
      { label: "Nearby", value: "Redlands · San Bernardino" },
      { label: "Commute", value: "Central I-10 access" }
    ],
    whyMove: [
      "A renowned medical university & hospital at its core",
      "One of America's healthiest, longest-living communities",
      "Walkable pockets and well-kept neighborhoods",
      "Central location — minutes from Redlands & the I-10",
      "Stable, community-minded atmosphere",
      "Ideal for healthcare workers and their families"
    ],
    lifestyle: "Loma Linda draws doctors, nurses, students, and healthcare workers connected to the medical center, along with families who appreciate its calm, community-minded atmosphere. Life here emphasizes health, wellness, and active living, with the convenience of a central IE location and quick access to Redlands.",
    consider: "Loma Linda is a compact city, so inventory can be tighter than in larger neighbors and you may pay a slight premium for the convenience of being close to the medical center. If you want more land or newer construction, compare it with Highland, Yucaipa, or Calimesa nearby.",
    nearby: ["Redlands", "San Bernardino", "Highland", "Grand Terrace", "Colton"],
    relatedPosts: [
      { slug: "living-in-loma-linda-ca-buyers-guide", title: "Living in Loma Linda, CA: A Buyer's Guide" },
      { slug: "moving-to-inland-empire-from-la-orange-county", title: "Moving to the IE from LA or OC: Loma Linda, Highland & Calimesa" },
      { slug: "living-in-redlands-ca-what-buyers-need-to-know", title: "Living in Redlands, CA — What Buyers Need to Know" }
    ]
  },
  {
    slug: "calimesa",
    name: "Calimesa",
    state: "CA",
    tagline: "New homes & small-town quiet",
    image: "https://images.unsplash.com/photo-1777245144143-fca70f22adf5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    blurb: "One of the Inland Empire's smallest and fastest-growing cities for new construction — perfect for buyers who want a brand-new home in a peaceful setting near Redlands and Yucaipa.",
    intro: "Tucked between Yucaipa and the Riverside County line, Calimesa is one of the Inland Empire's smallest and most peaceful cities — and one of its fastest-growing for new home construction. For buyers who want a brand-new home, a quiet setting, and easy access to Redlands and Yucaipa, Calimesa is a hidden gem worth exploring.",
    stats: [
      { label: "Vibe", value: "Peaceful & small-town" },
      { label: "Best for", value: "New-home buyers" },
      { label: "Nearby", value: "Yucaipa · Oak Glen" },
      { label: "Commute", value: "Easy I-10 access" }
    ],
    whyMove: [
      "Affordable new construction with modern floor plans",
      "A quiet, small-town atmosphere with open space nearby",
      "Minutes from Yucaipa's amenities and Oak Glen's orchards",
      "Energy-efficient homes, often with warranties",
      "Easy I-10 access toward Redlands and beyond",
      "Strong value versus comparable coastal homes"
    ],
    lifestyle: "Because so much of Calimesa's housing stock is new, buyers can often get modern features — open layouts, energy efficiency, and warranties — for less than comparable homes closer to the coast. Master-planned communities bring contemporary homes, while the city keeps a relaxed, rural-edge character that appeals to families leaving coastal congestion.",
    consider: "Calimesa is small and still growing, so amenities are more limited than in Redlands or Yucaipa — though those cities are just minutes away. For buyers who want peace, space, and a new home, that trade-off is often exactly the point.",
    nearby: ["Yucaipa", "Redlands", "Beaumont", "Oak Glen", "Cherry Valley"],
    relatedPosts: [
      { slug: "calimesa-ca-new-homes-small-town-living", title: "Calimesa, CA: New Homes & Small-Town Living" },
      { slug: "is-yucaipa-ca-a-good-place-to-live", title: "Is Yucaipa, CA a Good Place to Live?" },
      { slug: "moving-to-inland-empire-from-la-orange-county", title: "Moving to the IE from LA or OC: Loma Linda, Highland & Calimesa" }
    ]
  }
];

export const REDLANDS_IMAGE = "https://images.unsplash.com/photo-1635814081683-addf0706c795?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export const REDLANDS_ATTRACTIONS = [
  { icon: "Store", title: "Historic State Street", desc: "A walkable, tree-lined downtown packed with boutiques, cafés, and award-winning restaurants — the heart of Redlands life." },
  { icon: "Music", title: "The Redlands Bowl", desc: "Home to the longest continuously running free summer music festival in the U.S. — concerts under the stars all season." },
  { icon: "Landmark", title: "Kimberly Crest House & Gardens", desc: "A breathtaking 1897 French château and formal gardens that showcase the city's rich Victorian heritage." },
  { icon: "GraduationCap", title: "University of Redlands", desc: "A prestigious private university that brings culture, sports, and a vibrant college-town energy to the community." },
  { icon: "Trees", title: "Prospect Park & citrus groves", desc: "Historic orange groves and hilltop parks with sweeping valley views — a nod to the city's citrus legacy." },
  { icon: "Mountain", title: "Market Night & the mountains", desc: "Thursday-night street markets, plus quick access to hiking, skiing, and Big Bear just up the mountain." }
];


export const LISTING = {
  name: "The Crestview Estate",
  address: "1240 Summit Ridge Drive, Redlands, CA",
  status: "Just Listed",
  price: "$1,295,000",
  beds: 5,
  baths: 4.5,
  sqft: "4,120",
  lot: "0.42 acre",
  year: 2021,
  hero: "https://images.unsplash.com/photo-1759355787121-eaef014a501d?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  gallery: [
    "https://images.unsplash.com/photo-1648475236583-2e25a6cbf3bd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    "https://images.unsplash.com/photo-1687942691222-0876157ac76f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    "https://images.unsplash.com/photo-1781344334914-2d0bfac48887?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
  ],
  description:
    "Perched on a private rise with sweeping valley views, The Crestview Estate is a 2021-built architectural showpiece. Walls of glass dissolve the line between indoors and out, opening to a resort-style pool, outdoor kitchen, and sun-drenched great room. A chef's kitchen with waterfall island, a spa-inspired primary suite, and a flexible bonus level make this a rare blend of luxury and smart investment.",
  features: ["Resort-style pool & spa", "Chef's kitchen + butler's pantry", "Owned solar & EV charging", "Smart-home automation", "3-car garage", "Detached casita / office"]
};

// Illustrative 5-year equity build. Purchase $1,295,000, 20% down ($259,000),
// ~6.5% 30-yr loan ($1,036,000), 4% annual appreciation (estimates only).
export const EQUITY_PROJECTION = [
  { year: "At purchase", value: "$1,295,000", loan: "$1,036,000", equity: "$259,000" },
  { year: "Year 1", value: "$1,346,800", loan: "$1,023,900", equity: "$322,900" },
  { year: "Year 2", value: "$1,400,700", loan: "$1,011,000", equity: "$389,700" },
  { year: "Year 3", value: "$1,456,700", loan: "$997,200", equity: "$459,500" },
  { year: "Year 5", value: "$1,575,500", loan: "$967,800", equity: "$607,700" }
];

export const INVEST_REASONS = [
  { title: "Equity that compounds", outcome: "Projected ~$348k in equity gains over 5 years", desc: "Appreciation plus loan paydown quietly build wealth every single month you own." },
  { title: "Powerful leverage", outcome: "Control a $1.29M asset with ~20% down", desc: "Your returns are measured against your down payment, not the full price — magnifying gains." },
  { title: "Tax advantages", outcome: "Deduct mortgage interest & property taxes", desc: "Owners and investors enjoy deductions and, for investors, depreciation that shelters income." },
  { title: "Inflation hedge", outcome: "Values & rents historically rise with inflation", desc: "Real estate tends to outpace inflation while your mortgage payment stays fixed." },
  { title: "Cash-flow potential", outcome: "Strong SoCal rental demand", desc: "Held as an investment, premium homes in Redlands command premium, reliable rents." },
  { title: "Generational wealth", outcome: "A lasting, transferable asset", desc: "Real estate is one of the most proven vehicles for passing wealth to the next generation." }
];

// Refinance scenarios on the $1,036,000 loan if rates improve later (estimates only).
export const REFI_SCENARIOS = [
  { rate: "6.5% (today)", payment: "$6,549", monthly: "—", annual: "—" },
  { rate: "5.5%", payment: "$5,883", monthly: "$666", annual: "$7,992" },
  { rate: "5.0%", payment: "$5,562", monthly: "$987", annual: "$11,844" },
  { rate: "4.5%", payment: "$5,249", monthly: "$1,300", annual: "$15,600" }
];

export const REFI_IDEAS = [
  { title: "Rate-and-term refinance", desc: "When rates dip, lower your monthly payment without changing your loan balance — keep the savings or pay down principal faster." },
  { title: "Cash-out refinance", desc: "Tap built-up equity to fund your next investment property, renovations, or to consolidate higher-interest debt." },
  { title: "Drop your mortgage insurance", desc: "Once you reach ~20% equity, refinancing (or a re-appraisal) can remove PMI and cut your payment further." },
  { title: "Shorten your term", desc: "Refinance from a 30-year into a 15- or 20-year loan to own free-and-clear sooner and save tens of thousands in interest." }
];

export const HOW_WE_HELP = [
  { title: "Buyers find us first", desc: "Our listings are engineered for search and syndicated across Zillow, Google, and social — so qualified buyers discover your home before anyone else's." },
  { title: "Analytics-driven targeting", desc: "We track who's viewing, clicking, and saving — then put your property in front of look-alike buyers most likely to make an offer." },
  { title: "Smart digital ads", desc: "Geo- and interest-targeted campaigns follow active buyers across the web, maximizing every marketing dollar with measurable results." },
  { title: "Real-time insights", desc: "A live dashboard shows showing demand, online interest, and engagement — so pricing and strategy decisions are backed by data, not guesswork." },
  { title: "Professional Photography & Video", desc: "Every listing gets high-quality photos, cinematic drone footage, and even 3D virtual tours — so your home looks its absolute best and reaches buyers everywhere." },
  { title: "Neighborhood Lifestyle Guides", desc: "For every listing we publish a curated local guide — the best restaurants, parks, schools, and things to do nearby — so buyers can instantly picture their life in the area." }
];
